import React from 'react';
import { number } from 'prop-types';

import { colors, Row, Col, Typography } from '@ajaibid/components';
import { formatCurrency } from '@ajaibid/utils';

import { useStockBuySellContext } from '../../../hooks';

const SummaryTotal = (props) => {
  const { marginTop, marginBottom } = props;

  const { formState, formKey } = useStockBuySellContext();

  return (
    <Row noGutters align="between" marginTop={marginTop} marginBottom={marginBottom}>
      <Col size="auto">
        <Typography type="body" color={colors.NEUTRAL_7} margin={0}>
          Total
        </Typography>
      </Col>
      <Col size="auto">
        <Typography type="body" margin={0} data-testid="txt-orderTotal">
          {formatCurrency(formState[formKey.CALC_ORDER_TOTAL], 'IDR')}
        </Typography>
      </Col>
    </Row>
  );
};

SummaryTotal.propTypes = {
  marginTop: number,
  marginBottom: number,
};

SummaryTotal.defaultProps = {
  marginTop: 0,
  marginBottom: 0,
};

export default SummaryTotal;
